import React from 'react';

function AlertIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.5a.75.75 0 01.67.41l7.25 14.5a.75.75 0 01-.67 1.09H2.75a.75.75 0 01-.67-1.09l7.25-14.5A.75.75 0 0110 2.5zm0 5.25a.75.75 0 00-.75.75v3.5a.75.75 0 001.5 0v-3.5A.75.75 0 0010 7.75zm0 7.25a.875.875 0 100-1.75.875.875 0 000 1.75z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function InlineAlertBanner({
  message,
  actionLabel,
  onAction,
  loading = false,
  disabled = false,
  dir = 'ltr',
  inset = false,
  error = null,
  onDismiss,
  dismissLabel = 'Fermer',
}) {
  return (
    <div className={`kio-inline-alert${inset ? ' kio-inline-alert--inset' : ''}`} dir={dir}>
      <div className="kio-inline-alert__inner">
        <span className="kio-inline-alert__icon" aria-hidden="true">
          <AlertIcon />
        </span>
        <p className="kio-inline-alert__text">{message}</p>
        {actionLabel && (
          <button
            type="button"
            className="kio-inline-alert__btn"
            onClick={onAction}
            disabled={disabled || loading}
          >
            {loading ? '…' : actionLabel}
          </button>
        )}
        {onDismiss && (
          <button
            type="button"
            className="kio-inline-alert__dismiss"
            onClick={onDismiss}
            aria-label={dismissLabel}
          >
            ×
          </button>
        )}
      </div>
      {error && <p className="kio-inline-alert__error">{error}</p>}
    </div>
  );
}
